function initializeNavigation() {
  const toggle = document.querySelector('#menu-toggle');
  const menu = document.querySelector('#menu');

  if (toggle && menu) {
    toggle.addEventListener('click', () => {
      if (toggle.dataset.toggled === 'true') {
        toggle.dataset.toggled = 'false';
        menu.dataset.toggled = 'false';
      } else {
        toggle.dataset.toggled = 'true';
        menu.dataset.toggled = 'true';
      }
    });
  }
}

export { initializeNavigation };
